<form class="form-horizontal row form-inline" [formGroup]="form">
    <div class="col-lg-6">
        @if (!addMode) {
            <div class="d-flex align-items-center mb-3"
                 [ngClass]="{ 'has-error': editMode() && f.controls.filingType.touched && f.controls.filingType.errors }">
                <label for="filingType" class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">Batch
                    #:</label>
                <div class="flex-grow-1">
                    <p class="form-control-static mb-0">{{ model?.displayId }}</p>
                </div>
            </div>
        }

        <div class="d-flex align-items-center mb-3"
             [ngClass]="{ 'has-error': editMode() && f.controls.filingType.touched && f.controls.filingType.errors }">
            <label for="filingType" class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">Filing
                Type:</label>
            <div class="flex-grow-1">
                <p class="form-control-static mb-0">{{ f.controls.filingType.value?.name }}</p>
                @if (f.controls.filingType.touched && f.controls.filingType.errors) {
                    <div class="error-feedback">
                        @if (f.controls.filingType.errors.required) {
                            <div class="text-danger small">Filing Type is required.</div>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="d-flex align-items-center mb-3"
             [ngClass]="{ 'has-error': editMode() && f.controls.taxYear.touched && f.controls.taxYear.errors }">
            <label for="taxYear" class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">Tax Year:</label>
            <div class="flex-grow-1">
                @if (!editMode() || !addMode) {
                    <p class="form-control-static mb-0">{{ f.controls.taxYear.value }}</p>
                }
                @if (editMode() && addMode) {
                    <div class="d-inline-block">
                        <ws-select
                            formControlName="taxYear"
                            [options]="taxYears"
                            [isPrimitive]="true"
                            [sizeToContent]="true"
                            (selectedOptionChanged)="updateDeadlineForStateAndTaxYear()">
                        </ws-select>
                    </div>
                }
                @if (f.controls.taxYear.touched && f.controls.taxYear.errors) {
                    <div class="error-feedback">
                        @if (f.controls.taxYear.errors.required) {
                            <div class="text-danger small">Tax Year is required.</div>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="d-flex align-items-center mb-3"
             formGroupName="stateGroup"
             [ngClass]="{ 'has-error': editMode() && fState.controls.stateName.touched && fState.controls.state.errors }">
            <label for="state" class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">State:</label>
            <div class="flex-grow-1">
                @if (!editMode() || !addMode) {
                    <p class="form-control-static mb-0">{{ fState.controls.stateName.value }}</p>
                }
                @if (editMode() && addMode) {
                    <div class="d-inline-block">
                        <ws-select
                            formControlName="state"
                            placeholder="Select a state..."
                            labelProperty="fullName"
                            [returnEntireOption]="true"
                            [options]="states"
                            searchType="custom"
                            [customSearch]="customStateSearch"
                            [sizeToContent]="true"
                            (selectedOptionChanged)="onStateSelected($event)">
                        </ws-select>
                    </div>
                }
                @if (fState.controls.stateName.touched && fState.controls.state.errors) {
                    <div class="error-feedback">
                        @if (fState.controls.state.errors.required) {
                            <div class="text-danger small">State is required.</div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="col-lg-6">
        @if (!addMode) {
            <div class="d-flex align-items-center mb-3">
                <label class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">Status:</label>
                <div class="flex-grow-1">
                    <p class="form-control-static mb-0">
                        <span class="ace-btn btn-link pointer p-0 border-0"
                              (click)="viewTasks()"
                              helpTooltip
                              [helpContentId]="tasksHelpContentId"
                              position="bottom">
                            {{ model?.status }}
                        </span>
                    </p>
                </div>
            </div>
        }

        <div class="d-flex align-items-center mb-3"
             [ngClass]="{ 'has-error': editMode() && f.controls.description.touched && f.controls.description.errors }">
            <label for="description" class="flex-shrink-0 text-nowrap me-3 mb-0"
                   style="width: 160px">Description:</label>
            <div class="flex-grow-1">
                @if (!editMode()) {
                    <p class="form-control-static mb-0 ws-truncate-keep-spaces"
                       [title]="f.controls.description.value">{{ f.controls.description.value }}</p>
                }
                @if (editMode()) {
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Description"
                        autocomplete="off"
                        formControlName="description" />
                }
                @if (f.controls.description.touched && f.controls.description.errors) {
                    <div class="error-feedback">
                        @if (f.controls.description.errors.required) {
                            <div class="text-danger small">Description is required.</div>
                        }
                        @if (f.controls.description.errors.maxlength) {
                            <div class="text-danger small">Description max length is 4,000 characters.</div>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="d-flex align-items-center mb-3"
             [ngClass]="{ 'has-error': editMode() && f.controls.dueDate.touched && f.controls.dueDate.errors }">
            <label for="dueDate" class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">Due Date:</label>
            <div class="flex-grow-1">
                @if (!editMode()) {
                    <p class="form-control-static mb-0">{{ f.controls.dueDate.value | weissmanDateFormat: true }}</p>
                }
                @if (editMode()) {
                    <weissman-datetime
                        [dateOnly]="true"
                        [inputDate]="f.controls.dueDate.value"
                        (change)="onDueDateChanged($event)"
                        helpTooltip
                        helpContentId="app.date-picker"
                        position="bottom">
                    </weissman-datetime>
                }
                @if (f.controls.dueDate.touched && f.controls.dueDate.errors) {
                    <div class="error-feedback">
                        @if (f.controls.dueDate.errors.required) {
                            <div class="text-danger small">Due date is required.</div>
                        }
                    </div>
                }
            </div>
        </div>
        <div class="d-flex align-items-center mb-3"
             [ngClass]="{ 'has-error': editMode() && f.controls.changeDetection.touched && f.controls.changeDetection.errors }">
            <label class="flex-shrink-0 text-nowrap me-3 mb-0" style="width: 160px">
                <span helpTooltip
                      [isMultiline]="true"
                      [tooltipText]="changeDetectionHelpText"
                      [hasIcon]="true"
                      iconPosition="right"
                      position="right">
                    Change Detection:
                </span>
            </label>
            <div class="flex-grow-1">
                @if (!editMode() || model?.hasAmendmentReturns) {
                    <p class="form-control-static mb-0">{{ changeDetection }}</p>
                }
                @if (editMode() && !model?.hasAmendmentReturns) {
                    <ws-select class="d-inline-block"
                               [options]="changeDetectionOptions"
                               labelProperty="name"
                               valueProperty="value"
                               [sizeToContent]="true"
                               formControlName="changeDetection">
                    </ws-select>
                }
            </div>
        </div>
    </div>
</form>

